import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Category from '@/components/Category'
import Submit from '@/components/Submit'
import Confirm from '@/components/Confirm'
import QuickAdd from '@/components/QuickAdd'
import pixel from './pixel'
import google from './google'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },

    {
      path: '/categorie/:categorySlug([a-z0-9-]+)',
      name: 'category',
      component: Category,
      props: (route) => ({
        categorySlug: route.params.categorySlug,
        nomineeId: null,
      }),
    },

    {
      path: '/inzenden',
      name: 'submit',
      component: Submit,
    },

    {
      path: '/bevestigen/:uuid([a-z0-9-]{36})',
      name: 'confirm',
      component: Confirm,
      props: (route) => ({
        uuid: route.params.uuid,
      }),
    },
    {
      path: '*',
      redirect: '/',
    },

    {
      path: '/:categorySlug([a-z0-9-]+)/:nomineeSlug([a-z0-9-]+)',
      name: 'quick_add',
      component: QuickAdd,
      props: (route) => ({
        categorySlug: route.params.categorySlug,
        nomineeSlug: route.params.nomineeSlug,
      }),
    },
  ],
})

router.afterEach((to) => {
  try {
    pixel(to)
    google(to)
  } catch (e) {
    console.warn(e)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js